import { render, staticRenderFns } from "./professionalPersonnel.vue?vue&type=template&id=2d534105&scoped=true"
import script from "./professionalPersonnel.vue?vue&type=script&lang=js"
export * from "./professionalPersonnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d534105",
  null
  
)

export default component.exports